<template>
    <div
        v-if="
            (order.price_string && order.cost > 0) ||
            (order.has_discount && order.cost_info) ||
            order.price_info.price.amount ||
            (payment && payment.price)
        "
    >
        <flex-container class="mt-20 mb-20" align="center" :justify="$vssWidth <= '960' ? 'flex-start' : 'flex-end'">
            <default-title
                v-if="order.price_string && order.cost > 0"
                class="public-offer-order__total mr-5"
                small
                :line-height="21"
            >
                {{ t(showPartialPrice ? "payments.public-offer.amount" : "payments.invoice_amount_due") }}:
            </default-title>
            <template v-if="payment"
                ><b>{{ payment.price }} {{ payment.currency.code }}</b></template
            >
            <template v-else>
                <s class="discount" v-if="order.has_discount && order.cost_info"
                    >{{ order.cost_info.price.amount_formatted }}
                </s>
                <price-with-converted
                    class="amount-formatted"
                    v-if="order.price_info.price.amount"
                    :price="order.price_info.price.amount_formatted"
                    :show-converted="!!getVolatile(order.price_info)"
                    :price-converted="getVolatile(order.price_info)"
                    :default-currency="order.price_info.price.currency.code"
                    :absolute-converted-container="false"
                />
            </template>
        </flex-container>
        <flex-container
            v-if="showPartialPrice"
            class="mt-20 mb-30"
            align="center"
            :justify="$vssWidth <= '960' ? 'flex-start' : 'flex-end'"
        >
            <default-title
                v-if="order.price_string && order.cost > 0"
                class="public-offer-order__total mr-5"
                small
                :line-height="21"
            >
                {{ t("payments.invoice_amount_due") }}:
            </default-title>

            <template>
                <price-with-converted
                    class="amount-formatted"
                    v-if="order.price_info.price.amount"
                    :price="
                        showPartialPrice
                            ? paymentParts[0].price_info.price.amount_formatted
                            : order.price_info.price.amount_formatted
                    "
                    :show-converted="!!getVolatile(showPartialPrice ? paymentParts[0].price_info : order.price_info)"
                    :price-converted="getVolatile(showPartialPrice ? paymentParts[0].price_info : order.price_info)"
                    :default-currency="
                        showPartialPrice
                            ? paymentParts[0].price_info.price.currency.code
                            : order.price_info.price.currency.code
                    "
                    :absolute-converted-container="false"
                />
            </template>
        </flex-container>
    </div>
</template>

<script>
import FlexContainer from "@components/Containers/FlexContainer.vue"
import PriceWithConverted from "@components/PriceWithConverted.vue"
import DefaultTitle from "@components/Typography/DefaultTitle.vue"

export default {
    props: {
        order: {
            type: Object,
            default: () => {}
        },
        paymentParts: {
            type: Array,
            default: () => []
        },
        payment: {
            type: Object,
            default: null
        },
        showPartialPrice: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferOrderPrice",
    components: { DefaultTitle, FlexContainer, PriceWithConverted },
    mounted() {
        window.addEventListener("scroll", () => {
            this.$forceUpdate()
        })
    },
    methods: {
        scrollToOrder() {
            document?.querySelector(".public-offer-order").scrollIntoView()
        },
        isFixedVisible() {
            const el = document?.querySelector(".public-offer-order")

            if (!el) {
                return false
            }

            const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
                const { top, left, bottom, right } = el.getBoundingClientRect()
                const { innerHeight, innerWidth } = window
                return partiallyVisible
                    ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
                          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
                    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
            }

            return !elementIsVisibleInViewport(el, true)
        },
        getVolatile(price_info) {
            return !price_info.price_converted.to_show ? "" : `${price_info.price_converted.amount_formatted}`
        }
    }
}
</script>

<style scoped lang="sass">
.fixed-price
    background-color: #51565C
    height: 65px
    width: 100vw
    position: fixed
    bottom: 0
    left: 0
    right: 0
    z-index: 55
    display: flex
    align-items: center
    justify-content: center
    grid-gap: 20px
    font-family: Inter, sans-serif
    &::v-deep
        b
            color: #fff
            font-weight: 600
            font-size: 16px
        s
            color: #BFC3C8
            font-size: 13px
s
    color: #B5C1D2
    font-weight: 500
</style>
